<template>
    <v-container>
      <v-row>
        <v-col cols="12" md="8">
          <v-card>
            <v-card-title>
              <span class="text-h5">Edit Class Teacher Profile</span>
            </v-card-title>
  
            <v-card-subtitle>
              Update the information below.
            </v-card-subtitle>
  
            <v-card-text>
              <v-form v-model="valid" ref="form" @submit.prevent="submitForm">
  
                <!-- Teacher Name -->
                <v-text-field
                  v-model="formData.teacher_name"
                  label="Teacher Name"
                  required
                  :rules="[rules.required]"
                />
  
                <!-- Teacher Email -->
                <v-text-field
                  v-model="formData.teacher_email"
                  label="Teacher Email"
                  type="email"
                  required
                  :rules="[rules.required, rules.email]"
                />
  
                <!-- Teacher Password -->
                <v-text-field
                  v-model="formData.teacher_password"
                  label="New Password"
                  type="password"
                  required
                  :rules="[rules.required, rules.password]"
                />
  
                <!-- Confirm Password -->
                <v-text-field
                  v-model="formData.confirm_password"
                  label="Confirm Password"
                  type="password"
                  required
                  :rules="[rules.required, rules.password]"
                />
  
                <!-- Submit -->
                <v-btn :disabled="!valid" color="primary" @click="submitForm">
                  Save Changes
                </v-btn>
  
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    name: 'ProfileEdit',
    data() {
      return {
        valid: false,
        formData: {
          teacher_name: '',
          teacher_email: '',
          teacher_password: '',
          confirm_password: '',
        },
        rules: {
          required: v => !!v || 'This field is required.',
          email: v => /^[a-zA-Z0-9]+[a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) || 'Enter a valid email address.',
          password: v => v.length >= 6 || 'Password must be at least 6 characters.',
        },
      };
    },
    methods: {
      async submitForm() {
        if (this.formData.teacher_password !== this.formData.confirm_password) {
          this.$toast.error("Passwords don't match.");
          return;
        }
  
        try {
          const response = await axios.put('/api/school/teacher-profile', this.formData);
          
          if (response.data.status) {
            this.$toast.success('Profile updated successfully!');
            // Optionally, redirect the user after saving the profile.
            this.$router.push({ name: 'profile' });
          } else {
            this.$toast.error(response.data.message || 'Failed to update profile.');
          }
        } catch (error) {
          console.error('Error:', error);
          this.$toast.error('An error occurred while updating the profile.');
        }
      },
  
      async fetchProfile() {
        try {
             const user_id = localStorage.getItem('user_id');
          const response = await axios.get('/grade-dashboard/panelprofile', {
            params: { user_id: user_id }, // assuming userId is passed in route params
          });
  
          if (response.data.status) {
            // Populate the form data with fetched profile information
            const { user, grade } = response.data.data;
            this.formData.teacher_name = user.name;
            this.formData.teacher_email = user.email;
            // You can also pre-fill other form fields as needed
          } else {
            this.$toast.error(response.data.message || 'Failed to fetch profile data.');
          }
        } catch (error) {
          console.error('Error:', error);
          this.$toast.error('An error occurred while fetching the profile data.');
        }
      },
    },
    created() {
      this.fetchProfile();  // Fetch the profile data when the component is created
    },
  };
  </script>
  
  <style scoped>
  .v-card {
    max-width: 600px;
    margin: 20px auto;
  }
  </style>
  